import { Button } from '@mantine/core';

export function ErrorPanel({
  title,
  message,
  onRetry,
  retrying = false,
  retryLabel = 'Try again',
  embedded = false,
}: {
  title: string;
  message: string;
  onRetry?: () => void;
  retrying?: boolean;
  retryLabel?: string;
  embedded?: boolean;
}) {
  return (
    <section
      role="alert"
      className={
        embedded
          ? 'bg-surface-soft flex flex-col items-center gap-3 rounded-lg p-5'
          : 'border-hairline bg-surface shadow-card flex flex-col items-center gap-3 rounded-xl border p-5'
      }
    >
      <div className="flex flex-col gap-1 text-center">
        <h2 className="text-ink text-lg font-medium">{title}</h2>
        <p className="text-body">{message}</p>
      </div>
      {onRetry ? (
        <Button onClick={onRetry} loading={retrying}>
          {retryLabel}
        </Button>
      ) : null}
    </section>
  );
}
